import { render, staticRenderFns } from "./evaluation-result.vue?vue&type=template&id=e0ca882a"
import script from "./evaluation-result.vue?vue&type=script&lang=js"
export * from "./evaluation-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports